export class DialogModelAddBanner {
    constructor(
      public data: any
    ) {}
  }